/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { RichText, useBlockProps } from '@wordpress/block-editor';

const v3 = {
  attributes: {
    text: {
      type: 'string',
      source: 'html',
      selector: 'p'
    }
  },
  migrate({ text }) {
    return {
      content: text
    };
  },

  save({ attributes }) {
    return (
      <RichText.Content { ...useBlockProps.save() }
        tagName="p"
        value={ attributes.text }
      />
    );
  }
};

const v2 = {
  save() {
    return (
      <div { ...useBlockProps.save() }>
        Deprecation Example – hi from the saved content!
      </div>
    );
  }
};

const v1 = {
  save() {
    return (
      <div { ...useBlockProps.save() }>
        Deprecation Example – hello from the saved content!
      </div>
    );
  }
};

export default [ v3, v2, v1 ];
